import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import { Box, Typography } from '@mui/material';
import Swal from 'sweetalert2';
import { FormLabel } from '@mui/material';
import { useForm } from 'react-hook-form';
import request from '../../services/Request';
import '../user/form.css';
import { Modal } from '../../components/BootstrapToMUI';
import { useTheme } from '@mui/material/styles';

const updateAdress = '/machines/updateAdress';

export default function AddressModal(props) {
  const {
    reset,
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({});
  const theme = useTheme();
  const { data, user, setRowData, setMachines, ...rest } = props;

  const [loading, setLoading] = useState(true);

  const defaultValues = {
    location: data[0].address?.location ? data[0].address?.location : '',
    street: data[0].address?.street ? data[0].address?.street : '',
    city: data[0].address?.city ? data[0].address?.city : '',
    province: data[0].address?.province ? data[0].address?.province : '',
    postal_code: data[0].address?.postal_code ? data[0].address?.postal_code : '',
    country: data[0].address?.country ? data[0].address?.country : '',
    phone: data[0].address?.phone ? data[0].address?.phone : '',
    full_address: data[0].address?.full_address ? data[0].address?.full_address : '',
  };

  useEffect(() => {
    const initializeForm = async () => {
      if (props.show) {
        reset(defaultValues);
      }
    };
    initializeForm();
  }, [props.show]);

  const onSubmit = async (formData) => {
    setLoading(false);
    const address = {
      location: formData.location,
      street: formData.street,
      city: formData.city,
      province: formData.province,
      postal_code: formData.postal_code,
      country: formData.country,
      phone: formData.phone,
      full_address: formData.full_address,
    };
    const machineID = data.map((e) => e._id);

    await request({
      method: 'post',
      url: updateAdress,
      data: {
        machineID: machineID,
        address: address,
      },
    })
      .then((res) => {
        setLoading(true);

        setMachines((prevMachines) =>
          prevMachines.map((e) => (machineID.includes(e._id) ? { ...e, address: address } : e))
        );
        setRowData((prevRowData) =>
          prevRowData.map((e) => ({
            ...e,
            address: address,
          }))
        );

        Swal.fire({
          text: `Your changes has been updated!`,
          icon: 'success',
        }).then(() => {
          // window.location.reload();
          props.onHide();
        });
      })
      .catch((error) => {
        setLoading(true);
        Swal.fire({
          text: error?.response?.data?.message || 'Failed to update address',
          icon: 'Error',
        });
      });
  };

  return (
    <Modal className="modal-w" {...rest} centered size="sm">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" sx={{ fontSize: '1.2rem' }}>
          Update Settings
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <Box>
            <Box
              component="form"
              sx={{ width: '100%', mt: 3 }}
              onSubmit={handleSubmit(onSubmit)}
              noValidate
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sx={{ textAlign: 'center' }}>
                  <FormLabel component="legend">Address</FormLabel>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    label="Full Address (required)"
                    name="full_address"
                    inputProps={{
                      maxLength: '3000',
                    }}
                    {...register('full_address', {
                      required: 'Full address is required',
                      validate: {
                        hasMoreThanTwoCommas: (value) => {
                          // Check if the value is the special case
                          if (value === 'secret skip') {
                            return true; // Valid
                          }

                          // Otherwise, check if it has at least two commas
                          const commaCount = (value.match(/,/g) || []).length;
                          return (
                            commaCount >= 2 ||
                            'The address must contain at least two commas (e.g., "Street, City, State")'
                          );
                        },
                      },
                    })}
                    error={!!errors.full_address}
                    helperText={errors.full_address ? errors.full_address.message : ''}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2">
                    Full Address Example:1600 Amphitheatre Parkway, Mountain View, CA, USA
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Location (optional)"
                    name="location"
                    inputProps={{
                      maxLength: '100',
                    }}
                    {...register('location', {})}
                  />
                  {errors.location && (
                    <Typography className="signUpErrorMessage">
                      {errors.location.message}
                    </Typography>
                  )}
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Street"
                    name="street"
                    inputProps={{
                      maxLength: '100',
                    }}
                    {...register('street', {})}
                  />
                  {errors.street && (
                    <Typography className="signUpErrorMessage">{errors.street.message}</Typography>
                  )}
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="City"
                    name="city"
                    inputProps={{
                      maxLength: '25',
                    }}
                    {...register('city', {})}
                  />
                  {errors.city && (
                    <Typography className="signUpErrorMessage">{errors.city.message}</Typography>
                  )}
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Province/State(Abbr)"
                    name="province"
                    inputProps={{
                      maxLength: '25',
                    }}
                    {...register('province', {})}
                  />
                  {errors.city && (
                    <Typography className="signUpErrorMessage">{errors.city.message}</Typography>
                  )}
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Postal/Zip Code"
                    name="postal_code"
                    inputProps={{
                      maxLength: '25',
                    }}
                    {...register('postal_code', {})}
                  />
                  {errors.postal_code && (
                    <Typography className="signUpErrorMessage">
                      {errors.postal_code.message}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Country"
                    name="country"
                    inputProps={{
                      maxLength: '25',
                    }}
                    {...register('country', {})}
                  />
                  {errors.country && (
                    <Typography className="signUpErrorMessage">{errors.country.message}</Typography>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Phone Number"
                    name="phone"
                    inputProps={{
                      maxLength: '25',
                    }}
                    {...register('phone', {})}
                  />
                  {errors.phone && (
                    <Typography className="signUpErrorMessage">{errors.phone.message}</Typography>
                  )}
                </Grid>
              </Grid>

              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                disabled={!loading}
                sx={{ mt: 3, mb: 2 }}
              >
                Update
              </Button>
            </Box>
          </Box>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
